const state = {
  equipmentoptionList: [],
  addEquipmentOptionList: {},
  updateEquipmentOptionList: {},
  deleteEquipmentOptionList: {},
  sendEquipmentOptionPriority: {},
};

export default state;
